<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label style="text-align: left;font-size: 21px;font-weight: 500;color: #278ecd;"> 1 - Date Range</label>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <label style="color: firebrick;">From Date</label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class">
      </div>

      <div class="col-3">
        <label style="color: firebrick;">To Date</label>
        <input type="date" [(ngModel)]="to_date" [min]="from_date" class="main-border-class">
      </div>

      <div class="col-3">
        <label style="color: firebrick;">Incentive For</label>
        <mat-select [(ngModel)]="selected_incentive_for" class="main-border-class">
          <mat-option *ngFor="let options of incentive_for_list" [value]="options.value">{{options.display_name}}
          </mat-option>
        </mat-select>
      </div>


      <div class="col-2">
        <label style="color: firebrick;">Select Option</label>
        <mat-select [(ngModel)]="seleted_option_type" class="main-border-class" (ngModelChange)="changeOption()">
          <mat-option *ngFor="let options of option_list" [value]="options.value">{{options.display_name}}</mat-option>
        </mat-select>
      </div>

      <div class="col-1" *ngIf="seleted_option_type == 'amount'" style="margin-top: 2%;">
        <label style="font-size: 40px;">₹</label>
      </div>
      <div class="col-1" *ngIf="seleted_option_type == 'precentage'" style="margin-top: 2%;">
        <label style="font-size: 40px;">%</label>
      </div>

      <div class="col-3" *ngIf="seleted_option_type != null ">
        <label style="color: firebrick;">Incentive
          <span *ngIf="seleted_option_type == 'amount'">Amount ₹</span>
          <span *ngIf="seleted_option_type == 'precentage'">percentage %</span>
        </label>
        <input type="number" [(ngModel)]="option_value" class="main-border-class">
      </div>

      <div class="col-3" style="margin-top: 3%;">
        <mat-checkbox [(ngModel)]="is_tds_deduction_included" (ngModelChange)="tdsDeductionChange($event)"><label
            style="font-size: 20px;">Tds Deduction %</label></mat-checkbox>
      </div>

      <div class="col-3" *ngIf="is_tds_deduction_included">
        <mat-label>Deduction Amount</mat-label>
        <input type="number" [(ngModel)]="tds_value" class="main-border-class">
      </div>

      <div class="col-1" *ngIf="is_tds_deduction_included" style="margin-top: 2%;">
        <label style="font-size: 40px;">%</label>
      </div>

    </div><br>

    <div class="row">
      <div class="COL-2"></div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px; margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="from_date == null || to_date == null || selected_incentive_for == null || seleted_option_type == null || option_value == null">Get</button>
      </div>
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClickedForPdf()" style="margin-top: 7px;"><i
            class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>

      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClickedForExcel()" style="margin-top: 7px;"><i
            class="material-icons">
            get_app
          </i> Download Excel</button>
      </div>

    </div>

    <br><br><br>
  </div>
</section>
